import type { ZodIssue, ZodSchema } from "zod";

/**
 * Validate zod schema
 * @param schema - The zod schema to validate against
 * @param data - The data to validate
 * @returns [validatedData, errors] - The validated data and any errors
 */
export function validateSchema<T>(
  schema: ZodSchema<T>,
  data: unknown,
): [T | null, ZodIssue[] | null] {
  const validatedData = schema.safeParse(data);
  if (validatedData.success) {
    return [validatedData.data, null];
  }
  return [null, validatedData.error.errors];
}
